import { Component, OnInit } from '@angular/core';
import {} from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PersonService } from '../person.service';
import { DataSharingService } from '../shared/data-sharing.service';
import { DefaultUserAccount } from '../user-account';
import { PersonInterface, DefaultPersonTable } from '../person-interface';
import { UserAccount } from '../user-account';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import { provideHttpClient } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Other providers here
  ],
}).catch((err) => console.error(err));

@Component({
  selector: 'create-person-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  providers: [PersonService],
  template: `
    <h1 mat-dialog-title>{{ targetCaption_ }}</h1>

    <div mat-dialog-content [formGroup]="personForm_">
      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.NAME' | translate }}</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <!-- <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.LATIN_NAME' | translate }}</mat-label>
        <input matInput formControlName="latin_name" />
      </mat-form-field> -->

      <mat-form-field>
        <mat-label>{{
          'CREATE_PERSON.START_OF_FAMILY_NAME' | translate
        }}</mat-label>
        <input matInput formControlName="start_of_family_name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.DEATH_YEAR' | translate }}</mat-label>
        <input matInput formControlName="deathdate" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.BIRTH_YEAR' | translate }}</mat-label>
        <input matInput formControlName="birthdate" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.MOTHER_NAME' | translate }}</mat-label>
        <input matInput formControlName="mother_name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.COUNTRY_ID' | translate }}</mat-label>
        <input matInput formControlName="country_id" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.CITY_ID' | translate }}</mat-label>
        <input matInput formControlName="city_id" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.GENDER' | translate }}</mat-label>
        <mat-select formControlName="gender">
          <mat-option value="1">{{
            'CREATE_PERSON.MALE' | translate
          }}</mat-option>
          <mat-option value="2">{{
            'CREATE_PERSON.FEMALE' | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'CREATE_PERSON.NOTE' | translate }}</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </div>

    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>
        {{ 'CREATE_PERSON.CANCEL' | translate }}
      </button>
      <button mat-button (click)="savePerson()" cdkFocusInitial>
        {{ 'CREATE_PERSON.CREATE' | translate }}
      </button>
    </div>
  `,
  styleUrls: ['./create-person-dialog.component.css'],
})
export class CreatePersonDialogComponent implements OnInit {
  public personForm_: FormGroup;
  public userAccount_: UserAccount = new DefaultUserAccount();
  public targetPerson_: PersonInterface = new DefaultPersonTable();
  public targetUri_: string = '';
  public targetCaption_: string = '';
  private currentPersonId_: string = '';

  constructor(
    private personService_: PersonService,
    private dataSharingService_: DataSharingService,
    public dialogRef_: MatDialogRef<CreatePersonDialogComponent>,
    private fb_: FormBuilder,
    translate: TranslateService,
    private snackBar: MatSnackBar,
  ) {
    this.personForm_ = this.fb_.group({
      gender: ['1'], // Default to Male
    });
  }

  ngOnInit(): void {
    this.dataSharingService_.activeUserAccount$.subscribe((userAccount) => {
      this.userAccount_ = userAccount;
      this.userAccount_.gender = 1;
      this.personForm_ = this.fb_.group({
        name: ['', Validators.required],
        start_of_family_name: [''],
        deathdate: [''],
        birthdate: [''],
        mother_name: [''],
        country_id: [''],
        city_id: [''],
        gender: ['1'], // Default Male
        notes: [''],
      });
      console.log('User Account:', this.userAccount_);
    });

    this.dataSharingService_.targetPerson$.subscribe((targetPerson) => {
      this.targetPerson_ = targetPerson;
      console.log('Target Person:', this.targetPerson_);
    });

    this.dataSharingService_.activeUri$.subscribe((targetUri) => {
      this.targetUri_ = targetUri;
      console.log('Target URI:', this.targetUri_);
    });

    this.dataSharingService_.targetCaption$.subscribe((targetCaption) => {
      this.targetCaption_ = targetCaption;
      console.log('Target Caption:', this.targetCaption_);
    });

    this.currentPersonId_ = this.targetPerson_.id;
    this.personForm_ = this.fb_.group({
      name: [this.targetPerson_.name, Validators.required],
      start_of_family_name: [this.targetPerson_.start_of_family_name || ''],
      deathdate: [this.targetPerson_.deathdate || ''],
      birthdate: [this.targetPerson_.birthdate || ''],
      mother_name: [this.targetPerson_.mother_name || ''],
      country_id: [this.targetPerson_.country_id || ''],
      city_id: [this.targetPerson_.city_id || ''],
      gender: [
        this.targetPerson_.gender !== undefined
          ? this.targetPerson_.gender
          : '1',
      ], // Ensure default is Male
      notes: [this.targetPerson_.notes || ''],
    });

    this.personForm_.valueChanges.subscribe((value) => {
      this.dataSharingService_.setTargetPerson(value);
    });

    this.targetPerson_.owner_id = this.userAccount_.id;
    this.targetPerson_.id = this.currentPersonId_;
    console.log('User Email:', this.userAccount_.email);
    console.log('Person ID:', this.targetPerson_.id);
    console.log('URI:', this.targetUri_);
  }

  savePerson(): void {
    const targetPerson_ = this.dataSharingService_.getTargetPerson();
    const targetUri_ = this.dataSharingService_.getActiveUri();
    this.targetPerson_.owner_id = this.userAccount_.id;
    this.targetPerson_.id = this.currentPersonId_;

    this.personService_.run(targetPerson_, targetUri_).subscribe({
      next: (response) => {
        console.log('Person saved successfully:', response);

        // Show success message
        this.snackBar.open(
          response.message || 'Person created successfully',
          'Close',
          {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          },
        );

        this.dialogRef_.close();
      },
      error: (error) => {
        console.error('Error saving person:', error);

        // Extract ancestor names or fallback
        const ancestorNames =
          error?.error?.message && typeof error.error.message === 'string'
            ? error.error.message.trim()
            : 'No ancestor data available';

        // Show the first snackbar for the message
        this.snackBar.open(
          'This person already has a father. Have a look at his ancestors.',
          'Close',
          {
            duration: 3000,
            horizontalPosition: 'left',
            verticalPosition: 'top',
          },
        );

        // Delay the second snackbar for the ancestor names
        setTimeout(() => {
          this.snackBar.open(ancestorNames, 'Close', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
          });
        }, 3000); // Show second snackbar after the first one disappears
      },
    });
  }
}
